import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header as DSHeader, SideMenuTreeProps } from '@shape-ds/components';
import { ASSET_PAGE, HOME_PATH } from 'config/paths';
import { useAssetsByWorkspaceQuery } from 'queries/assets/queries';
import './style.scss';
import { useMemo } from 'react';
import { useFeatureFlag } from '@shape/feature-flag';
import { useTabsDefault } from './tabsConfig';
import { useUserMenu } from './components/UserMenu/hooks/useUserMenu';
import { useBreadcrumb } from './hooks/useBreadCrumb';
import Logo from '../../assets/images/lighthouse-logo.svg?react';

export const Header = () => {
  const { t } = useTranslation();
  const { assetId } = useParams();
  const tabsDefault = useTabsDefault();
  const navigate = useNavigate();
  const userMenuProps = useUserMenu();
  const showProductsMenu = useFeatureFlag('hubProducts');

  const trail = useBreadcrumb(assetId);

  const assetsAllQuery = useAssetsByWorkspaceQuery();
  const menuTreeData = useMemo(():
    | Omit<SideMenuTreeProps, 'isSidebarOpen' | 'onCloseSidebar'>
    | undefined => {
    if (!assetsAllQuery.data) return undefined;
    return {
      data: assetsAllQuery.data?.items[0].children ?? [],
      onClickItemHandler: (item) => {
        navigate(ASSET_PAGE(item.id), { replace: true });
      },
      activeItemId: assetId,
      homeItemProps: {
        text: assetsAllQuery.data?.items[0].name ?? 'Home',
        onClickHandler: () => navigate(ASSET_PAGE(), { replace: true }),
      },
      className: 'menu-tree',
    };
  }, [assetsAllQuery.data, assetId, navigate]);

  return (
    <DSHeader
      maxWidth={false}
      menuTree={menuTreeData}
      userMenu={userMenuProps}
      tabs={tabsDefault}
      breadcrumb={trail}
      placeholderText={t('components:event_list.filters.search')}
      showProductsMenu={showProductsMenu}
      productsMenuActiveItem="Lighthouse"
      initialActiveItemId={assetId}
    >
      <Link to={HOME_PATH} className="logo-link">
        <Logo className="logo-lighthouse" />
      </Link>
    </DSHeader>
  );
};
